import React from "react";
import { Star } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { cn } from "../../../lib/utils";

interface RepositoryFavoriteButtonProps {
  isFavorite: boolean;
  onToggle: () => void;
}

const RepositoryFavoriteButton = ({
  isFavorite,
  onToggle,
}: RepositoryFavoriteButtonProps) => {
  return (
    <Button
      variant="ghost"
      size="icon"
      title={isFavorite ? "Remove from favorites" : "Add to favorites"}
      onClick={(event) => {
        event.stopPropagation();
        onToggle();
      }}
    >
      <Star
        className={cn(
          "h-4 w-4",
          isFavorite ? "fill-yellow-400 text-yellow-500" : "text-muted-foreground"
        )}
      />
    </Button>
  );
};

export default RepositoryFavoriteButton;
